import React from 'react'
import './text.css'

const Text = ({isClickable, className, content}) => {
  const classNames = ['text-content']
  if (className) {
    classNames.push(className)
  }
  if (isClickable) {
    classNames.push('content-is-clickable')
  }
  return (
    <div className={classNames.join(' ')} dangerouslySetInnerHTML={{__html:content}}>
    </div>
  )
}

export default Text



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/text/Text.js